import React, { useState } from 'react';
interface MenuItem {
  title: string;
  url: string;
  children?: {
    title: string;
    url: string;
  }[];
}
const menuItems: MenuItem[] = [{
  title: 'Law Enforcement',
  url: '/law-enforcement-capabilities'
}, {
  title: 'Crisis Planning',
  url: '/crisis-management-planning'
}, {
  title: 'Corporate',
  url: '/corporate-critical-incidents-planning'
}, {
  title: 'Civilian',
  url: '/civilian-protection'
}, {
  title: 'Training',
  url: '/training'
}, {
  title: 'Resources',
  url: '/strategic-partners',
  children: [{
    title: 'Blog',
    url: '/blog'
  }]
}, {
  title: 'About',
  url: '/medina-tactical-dynamics',
  children: [{
    title: 'Meet the Founder',
    url: '/meet-the-founder'
  }]
}];
export function DesktopMenu() {
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  return <div className="hidden lg:flex flex-1 items-center justify-center gap-5" data-id="element-86">
      {menuItems.map(item => <div key={item.title} className="flex items-center" data-id="element-87">
          {item.children ? <div className="relative flex items-center gap-0.5" onMouseEnter={() => setOpenDropdown(item.title)} onMouseLeave={() => setOpenDropdown(null)} data-id="element-88">
              <a href={item.url} className="text-[13px] font-medium text-brand-gray-300 hover:text-brand-teal uppercase tracking-wider transition-colors leading-none" data-id="element-89">
                {item.title}
              </a>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={`w-3 h-3 text-brand-gray-300 transition-transform flex-shrink-0 ${openDropdown === item.title ? 'rotate-180' : ''}`} data-id="element-90">
                <path d="m6 9 6 6 6-6" data-id="element-91" />
              </svg>

              {openDropdown === item.title && <div className="absolute top-full left-0 pt-2 w-56 z-50" data-id="element-92">
                  <div className="bg-brand-gray-900 border border-brand-gray-700 shadow-xl" data-id="element-93">
                    {item.children.map(child => <a key={child.title} href={child.url} className="block px-4 py-3 text-xs font-medium text-brand-gray-300 hover:text-brand-teal hover:bg-brand-gray-800 uppercase tracking-wider transition-colors border-b border-brand-gray-800 last:border-0" data-id="element-94">
                        {child.title}
                      </a>)}
                  </div>
                </div>}
            </div> : <a href={item.url} className="text-[13px] font-medium text-brand-gray-300 hover:text-brand-teal uppercase tracking-wider transition-colors leading-none" data-id="element-95">
              {item.title}
            </a>}
        </div>)}
    </div>;
}